export class RegionsFilter {
  public regionsFilter = '';
  public genome = '';
}

